import { useEffect, useState } from 'react'
import type { Match } from '@brochure/shared'
import { elapsedAt } from '@/lib/match-clock'

type TimerMatch = Pick<Match, 'timerElapsed' | 'timerRunning' | 'timerStartedAt'>

/** Secondi trascorsi nella partita: ricalcolati subito e poi ogni secondo mentre il timer del server
 * è in corsa (`setInterval`, ripulito al cambio di stato o allo smontaggio). */
export function useMatchTimer(match: TimerMatch | undefined): number {
  const [elapsed, setElapsed] = useState(() => (match ? elapsedAt(match, new Date()) : 0))

  useEffect(() => {
    if (!match) return
    setElapsed(elapsedAt(match, new Date()))
    if (!match.timerRunning) return
    const interval = setInterval(() => setElapsed(elapsedAt(match, new Date())), 1000)
    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- confrontiamo i campi del timer, non l'identità dell'oggetto match
  }, [match?.timerElapsed, match?.timerRunning, match?.timerStartedAt])

  return elapsed
}
